var list = [];
export function push(popup) {
  list.push(popup);
}
export function pop() {
  var popup = list.pop();

  if (popup) {
    popup.value = false;
  }

  return popup;
}